import { action, makeObservable, observable } from 'mobx';

export interface AutocompleteV2ViewModelState<TValue> {
   value?: TValue | null;
   inputValue?: string;
   open?: boolean;
}

export class AutocompleteV2ViewModel<TValue = unknown> {
   opened = false;
   value: TValue | null = null;
   inputValue = '';

   constructor(state: AutocompleteV2ViewModelState<TValue> = {}) {
      makeObservable(this, {
         opened: observable,
         value: observable,
         inputValue: observable,
         setOpened: action.bound,
         setValue: action.bound,
         setInputValue: action.bound,
         select: action.bound,
         clear: action.bound,
      });

      this.opened = state.open ?? false;
      this.value = state.value ?? null;
      this.inputValue = state.inputValue ?? '';
   }

   setOpened(open: boolean): void {
      this.opened = open;
   }

   setValue(value: TValue | null): void {
      this.value = value;
   }

   setInputValue(value: string): void {
      this.inputValue = value;
   }

   select(value: TValue, inputValue: string): void {
      this.value = value;
      this.inputValue = inputValue;
   }

   clear(): void {
      this.value = null;
      this.inputValue = '';
   }
}
